/**
 * Created by iamso on 23.11.2021
 */

const LockedComponentView = cc.Node.extend({
    ctor: function (locked, unitParentView) {
        this._super();

        if (!cleverapps.config.demoMode) {
            this.setContentSize2(unitParentView.getContentSize());
        }

        this.locked = locked;
        this.unitView = unitParentView;

        if (cleverapps.environment.isEditorScene()) {
            this.addEditorSwitch();
            return;
        }

        this.restoreState();
        cleverapps.bundleLoader.ensureSoundsLoaded([bundles.ui.urls.unitlock_open, bundles.ui.urls.unitlock_start_unlock]);
    },

    restoreState: function (animated) {
        if (cleverapps.environment.isEditorScene()) {
            this.updateEditorLockColor();
            return;
        }

        if (!this.locked.isLockActive()) {
            this.removeLockIcon(animated);
            this.removeTimer(animated);
            return;
        }

        this.createLockIcon(animated);

        if (this.locked.isUnlockInProcess() && this.locked.getTimeLeft() > 0) {
            this.createTimer(animated);
        } else {
            this.removeTimer(animated);
        }
    },

    createLockIcon: function (animated) {
        const styles = cleverapps.styles.LockedComponentView.lock;

        if (!this.lockIcon) {
            this.lockIcon = new cleverapps.Spine(bundles.merge.jsons.unit_lock_json);
            this.addChild(this.lockIcon);
        }

        if (this.locked.isUnlockInProcess()) {
            this.lockIcon.setAlignment(this.width / 2, this.height / 2);
            this.lockIcon.setAnimation(0, "lock", true);

            if (animated) {
                cleverapps.effects.fire("merge.unitlock.start");
                this.lockIcon.setAlignment(this.width + styles.dx, styles.dy);
                this.lockIcon.runAction(new cc.MoveTo(0.25, cc.p(this.width / 2, this.height / 2)));
            }
        } else {
            this.lockIcon.setAnimation(0, "idle", true);
            this.lockIcon.setAlignment(this.width + styles.dx, styles.dy);
        }
    },

    removeLockIcon: function () {
        if (this.lockIcon) {
            this.lockIcon.removeFromParent();
            this.lockIcon = undefined;
        }
    },

    createTimer: function (animated) {
        if (this.unitView.getAdditionalView("timer")) {
            return;
        }

        const styles = cleverapps.styles.LockedComponentView.timer;
        const timer = new LockedComponentTimer(this.locked);
        timer.setAlignment(styles);

        if (animated) {
            this.unitView.animateAppearAdditionalView("timer", timer);
        } else {
            this.unitView.createAdditionalView("timer", timer);
        }
    },

    removeTimer: function (animated) {
        this.unitView.removeAdditionalView("timer", !animated);
    },

    unlock: function () {
        if (this.lockIcon) {
            cleverapps.effects.fire("merge.unitlock.open");
            this.lockIcon.setAnimation(0, "open", false);
            this.lockIcon.setCompleteListenerRemove();
            this.lockIcon = undefined;
        }
    },

    getUnlockAnimationDuration: function () {
        const animation = this.lockIcon && this.lockIcon.getAnimationData("open");
        return animation && animation.duration || 0;
    },

    updateEditorLockColor: function () {
        if (this.editorLockIcon) {
            const activeColor = new cc.Color(255, 255, 255);
            const inactiveColor = new cc.Color(120, 120, 120);
            this.editorLockIcon.setColor(this.locked.isLockActive() ? activeColor : inactiveColor);
        }
    },

    addEditorSwitch: function () {
        if (this.locked.unit.chooser) {
            return;
        }

        this.editorLockIcon = new cc.Sprite(bundles.merge.frames.unit_lock_png);
        this.editorLockIcon.scale = this.editorLockIcon.baseScale = 0.6;
        this.editorLockIcon.setAlignment({ x: { align: "center" }, y: { align: "bottom" } });
        this.addChild(this.editorLockIcon);

        this.updateEditorLockColor();

        cleverapps.UI.applyHover(this.editorLockIcon, {
            filter: function () {
                return !Editor.currentEditor.map.fogs.selected;
            }
        });

        cleverapps.UI.onClick(this.editorLockIcon, () => {
            const unit = this.locked.unit;
            Editor.currentEditor.doCommand("toggleLock", {
                x: unit.x, y: unit.y, hash: unit.getUnitHash()
            });
        }, {
            filter: function () {
                return !Editor.currentEditor.map.fogs.selected;
            }
        });
    }
});

cleverapps.styles.LockedComponentView = {
    timer: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 0 }
    },

    lock: { dx: -30, dy: 30 }
};
